import * as React from "react";
const CheckboxIndeterminate = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 2", fill: "currentColor", width: size || "8", height: size || "2", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H8V2H0z" }));
CheckboxIndeterminate.displayName = "CheckboxIndeterminate";
var CheckboxIndeterminate_default = CheckboxIndeterminate;
export {
  CheckboxIndeterminate_default as default
};
